import md5 from "md5";

/** Prepares a raw password for sending in a request. Prepends 'deltamath' and md5s the result. */
export function processPasswordForRequest(password: string): string {
  return md5(`deltamath${password.trim()}`);
}
